export default {
  model (resource) {
    return Object.assign({
      name: null,
      description: null,
      rules: [],
      type: null,
      activities: [],
      surface: null
    }, resource)
  },
  rules () {
    return {
      name: [
        {required: true, message: 'El nombre es requerido'},
        {min: 1, max: 255, message: 'El contenido debe ser entre 1 y 255 carácteres'}
      ],
      description: [
        {required: true, message: 'La descripción es requerida'},
        {min: 1, max: 255, message: 'El contenido debe ser entre 1 y 255 carácteres'}
      ],
      rules: [
        {type: 'array', required: true, message: 'Debe agregar algún elemento de la lista', trigger: 'blur'}
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/campaigns/campaign-list-customer-model.js